/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./OfferRedemptionPopup.scss";
import { useHistory } from "react-router-dom";

// material ui
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

// localizations
import { withTranslation, useTranslation } from "react-i18next";
// redux
import { useSelector, useDispatch } from "react-redux";
import { get_lang } from "../../../../global-functions/apiGlobal";
import boubyanImg from "../../../js/assets/images/bobeyan.png";

function OfferRedemptionPopup({ offer, onClose }) {
  const history = useHistory();
  const appDispatch = useDispatch();
  const { t } = useTranslation();
  const appState = useSelector((state) => state);

  // Debug logging
  console.log("OfferRedemptionPopup rendered with offer:", offer);

  useEffect(() => {
    console.log("OfferRedemptionPopup mounted");
    return () => {
      console.log("OfferRedemptionPopup unmounted");
    };
  }, []);

  const handleClose = () => {
    console.log("Closing popup");
    if (onClose) {
      onClose();
    }
  };

  const handleRedeem = () => {
    // Handle redemption logic here
    console.log("Redeeming offer:", offer);
    // You can dispatch actions here to handle the redemption
    handleClose();
  };
  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 2,
        }}
        open={true}
        className="offerRedemptionBackdrop"
        onClick={handleClose}
      />

      <div
        id="offerRedemptionPopup"
        className={`offerRedemptionPopup pb-3 ${
          appState.langValue == "ar" ? "ArabicOfferRedemptionPopup" : ""
        } offerRedemptionPopupActive  d-flex flex-column justify-content-center align-items-center` }
        style={{
          // Debug styles to ensure visibility
          transform: 'translateY(10px)',
          backgroundColor: 'white !important',
          zIndex: 9999,
        }}
      >
        {/* Close Button */}
        <div className="close-button-container">
          <button className="close-button" onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>

        {/* Main Content */}
        <div className="offer-content">
          {/* Illustration */}
          {offer?.image ? (
            <div className="offer-illustration">
              <img src={offer.image} alt="Offer Illustration" width={130} height={130} />
            </div>
          ) : (
          <div className="offer-illustration">
            <div className="illustration-container">
              {/* Abstract illustration with ribbon, scooter, and cube */}
              <div className="illustration-elements">
                <div className="ribbon"></div>
                <div className="scooter"></div>
                <div className="cube">
                  <span className="cube-logo">t</span>
                </div>
                <div className="floating-shapes">
                  <div className="shape shape-1"></div>
                  <div className="shape shape-2"></div>
                  <div className="shape shape-3"></div>
                </div>
              </div>
            </div>
          </div>)}

          {/* Offer Title */}
          <div className="offer-title">
              <h2>{get_lang (offer?.name, appState.langValue)}</h2>
          </div>

          {/* Offer Details */}
            {/* <div className="offer-details " >
              <div className="detail-item">
                <div className="detail-icon">
                  <div className="coin-stack">
                    <div className="coin coin-1">
                      <span className="coin-logo">t</span>
                    </div>
                    <div className="coin coin-2"></div>
                    <div className="coin coin-3"></div>
                  </div>
                </div>
                <div className="detail-text">
                  <span className="detail-label">Redeem For</span>
                  <span className="detail-value">{offer?.points || "500"} points</span>
                </div>
              </div>

              <div className="detail-item">
                <div className="detail-icon">
                  <div className="coins-with-sparkles">
                    <div className="coin orange-coin">
                      <span className="coin-logo">t</span>
                    </div>
                    <div className="coin brown-coin"></div>
                    <div className="sparkle sparkle-1">✨</div>
                    <div className="sparkle sparkle-2">✨</div>
                    <div className="sparkle sparkle-3">✨</div>
                  </div>
                </div>
                <div className="detail-text">
                  <span className="detail-label">Min Spend</span>
                  <span className="detail-value">KD {offer?.minSpend || "4.5"}</span>
                </div>
              </div>

              <div className="detail-item">
                <div className="detail-icon">
                  <div className="calendar">
                    <div className="calendar-header">
                      <div className="calendar-day marked">{offer?.validDays || "14"}</div>
                    </div>
                    <div className="calendar-body">
                      <div className="calendar-grid">
                        <div className="calendar-cell"></div>
                        <div className="calendar-cell"></div>
                        <div className="calendar-cell"></div>
                        <div className="calendar-cell"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="detail-text">
                  <span className="detail-label">Valid For</span>
                  <span className="detail-value">{offer?.validDays || "14"} days</span>
                </div>
              </div>
            </div> */}

          {/* Redeem Button */}
          {/* <div className="redeem-button-container">
            <Button
              className="redeem-button"
              onClick={handleRedeem}
              variant="contained"
            >
              Redeem
            </Button>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default withTranslation()(OfferRedemptionPopup);
